import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { MemberDetailRequestBody, MemberDetailResponse } from "./types";

export class MemberDetailAPI extends BaseAPI<
    MemberDetailRequestBody,
    MemberDetailResponse
> {
    protected route = ApiRoutes.member.detail;
    protected method = RequestMethod.GET;
}
